/* vr-footer.js — footer link columns.
   The columns are <details> so they can be accordions on mobile. On desktop they
   must always be open. Forcing that in CSS is NOT reliable: Chrome hides a closed
   <details>'s content through ::details-content { content-visibility: hidden },
   so overriding the child's display gives it layout but it never paints.
   Setting the `open` property is the portable way to do it.
   Without JS every column renders expanded, which is still correct and readable. */
(() => {
  if (window.__vrFooter) return;
  window.__vrFooter = true;

  const MOBILE = '(max-width: 749px)';

  const init = (root) => {
    const cols = [...(root || document).querySelectorAll('.vr-footer-col')];
    if (!cols.length) return;

    const mq = window.matchMedia(MOBILE);
    // Desktop: everything open. Mobile: every column collapsed until tapped
    // (client, 2026-09-14 — the Figma mobile frame's open first column is
    // overruled). Only re-applied when the breakpoint changes, so a visitor's
    // own toggling is never yanked back.
    const apply = () => cols.forEach((d) => { d.open = !mq.matches; });

    apply();
    mq.addEventListener('change', apply);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Theme editor: re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
